import styled from "styled-components";
import { PaymentButtonSlot } from "../components/PaymentButton";

const PAYMENT_FORM_FOOTER_SPACING = "64px";

export const PaymentFormFooter = styled.div`
  width: 100%;
  margin-top: auto;
  padding-top: ${PAYMENT_FORM_FOOTER_SPACING};
`;

export const PaymentFormButtonSlot = styled(PaymentButtonSlot)`
  margin-top: 0;
  padding-top: 0;
`;
